import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EditQuestionService {
  private editingQuestionIdsSubject = new BehaviorSubject<string[]>([]);
  editingQuestionIds$: Observable<string[]> =
    this.editingQuestionIdsSubject.asObservable();

  private showFlerpartsProjektSubject = new BehaviorSubject<boolean>(false);
  showFlerpartsProjekt$ = this.showFlerpartsProjektSubject.asObservable();

  startEditingQuestion(questionId: string): void {
    const ids = this.editingQuestionIdsSubject.getValue();
    if (!ids.includes(questionId)) {
      this.editingQuestionIdsSubject.next([...ids, questionId]);
    }
  }

  stopEditingQuestion(questionId: string): void {
    const ids = this.editingQuestionIdsSubject
      .getValue()
      .filter((id) => id !== questionId);
    this.editingQuestionIdsSubject.next(ids);
  }

  getEditingQuestionIds(): string[] {
    return this.editingQuestionIdsSubject.getValue();
  }

  clearEditingQuestions(): void {
    this.editingQuestionIdsSubject.next([]);
  }

  setShowFlerpartsProjekt(show: boolean): void {
    this.showFlerpartsProjektSubject.next(show);
  }
}
